import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
import { components } from '@/types/strapi';

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export const truncate = (text: string, length: number) => {
	return text.length > length ? text.slice(0, length) + '...' : text;
};

export const formatNumber = (
	number: number,
	locale: string = 'en-US',
): string => {
	return new Intl.NumberFormat(locale, {
		style: 'decimal',
		minimumFractionDigits: 0,
		maximumFractionDigits: 2,
	}).format(number);
};

export const getOptimalImageUrl = (
	trust_seal:
		| components['schemas']['DynamicZoneHeroComponent']['trust_seal']
		| components['schemas']['Logo']['image'],
) => {
	if (!trust_seal?.formats) {
		return trust_seal;
	}

	const formats = trust_seal.formats as {
		large?: { url: string; width: number; height: number };
		medium?: { url: string; width: number; height: number };
		small?: { url: string; width: number; height: number };
		thumbnail?: { url: string; width: number; height: number };
	};

	// Try to get the smallest format that's still large enough for our needs
	const format = formats.small || formats.medium || formats.thumbnail;
	return format || trust_seal;
};

export function getPathname(url?: string): string | null {
	try {
		if (!url) return null;
		const parsed = new URL(url);
		const allowedHosts = ['mtalkz.com', 'www.mtalkz.com'];
		if (!allowedHosts.includes(parsed.hostname)) return null;
		return parsed.pathname;
	} catch {
		return null;
	}
}
